<div class="shell" [class.collapsed]="collapsed" [class.mobile-open]="mobileOpen">
  <aside class="side" aria-label="Main navigation">
    <div class="sb-head">
      <a routerLink="/dashboard" class="sb-brand" title="AGW Agency Portal">
        <span class="logo">AP</span>
        <span class="sb-text text-sm font-semibold text-foreground">AGW Agency Portal</span>
      </a>
    </div>

    <nav class="sb-scroll">
      <div class="sb-group">
        <div class="sb-label sb-text">Manage</div>
        <div class="nav">
          @for (item of manageNav; track item.path) {
            <a
              class="nav-item"
              [routerLink]="item.path"
              routerLinkActive="on"
              [attr.title]="collapsed ? item.label : null"
            >
              <app-icon [name]="item.icon" />
              <span class="sb-text">{{ item.label }}</span>
            </a>
          }
        </div>
      </div>

      <div class="sb-group">
        <div class="sb-label sb-text">Agency</div>
        <div class="nav">
          <a
            class="nav-item"
            routerLink="/settings"
            routerLinkActive="on"
            [attr.title]="collapsed ? 'Settings' : null"
          >
            <app-icon name="settings" />
            <span class="sb-text">Settings</span>
          </a>
        </div>
      </div>

      <div class="sb-group">
        <div class="sb-label sb-text">Resources</div>
        <div class="nav">
          @for (item of resources; track item.label) {
            <a
              class="nav-item"
              [href]="item.url"
              target="_blank"
              rel="noopener"
              [attr.title]="collapsed ? item.label : null"
            >
              <app-icon [name]="item.icon" />
              <span class="sb-text">{{ item.label }}</span>
              <app-icon name="arrow-up-right" class="sm ext sb-text" />
            </a>
          }
        </div>
      </div>
    </nav>

    <div class="sb-foot">
      <div class="sb-text flex min-w-0 flex-col leading-tight">
        <span class="truncate text-xs font-medium">{{ email }}</span>
        <span class="text-[11px] text-muted-foreground">{{ roleLabel }}</span>
      </div>
      <div class="sb-actions">
        <button
          type="button"
          class="btn btn-ghost btn-icon"
          title="Account settings"
          aria-label="Account settings"
          (click)="openAccountSettings()"
        >
          <app-icon name="user-cog" />
        </button>
        <button
          type="button"
          class="btn btn-ghost btn-icon"
          title="Sign out"
          aria-label="Sign out"
          (click)="logout()"
        >
          <app-icon name="logout" />
        </button>
      </div>
    </div>
  </aside>

  @if (mobileOpen) {
    <div class="side-backdrop" (click)="mobileOpen = false"></div>
  }

  <div class="content">
    <header class="topbar">
      <button
        type="button"
        class="btn btn-ghost btn-icon"
        aria-label="Toggle sidebar"
        (click)="toggleSidebar()"
      >
        <app-icon name="panel" />
      </button>
      <div class="flex-1"></div>

      <div class="switcher">
        <button
          type="button"
          class="btn btn-outline btn-sm"
          aria-haspopup="listbox"
          [attr.aria-expanded]="switcherOpen"
          [attr.aria-label]="agencies.length ? 'Switch agency' : null"
          [style.cursor]="agencies.length ? 'pointer' : 'default'"
          (click)="toggleSwitcher()"
        >
          <span class="avatar xs">{{ agencyInitial }}</span>
          <span class="max-w-[220px] truncate">{{ currentAgency?.name || agencyName }}</span>
          @if (currentAgency?.iata_number) {
            <span class="hidden text-muted-foreground sm:inline">
              · IATA {{ currentAgency?.iata_number }}
            </span>
          }
          @if (agencies.length) {
            <app-icon name="chevrons" class="sm text-muted-foreground" />
          }
        </button>

        @if (switcherOpen) {
          <div class="card pop switcher-menu" role="listbox" aria-label="My agencies">
            <label class="flex items-center gap-2 border-b border-border px-3 py-2.5">
              <app-icon name="search" class="text-muted-foreground" />
              <input
                class="w-full border-0 bg-transparent text-sm outline-none"
                placeholder="Search agencies…"
                aria-label="Search agencies"
                [(ngModel)]="agencyQuery"
              />
            </label>
            <div class="max-h-72 overflow-auto p-1">
              <div class="sb-label h-7">My agencies</div>
              @for (agency of filteredAgencies; track agency.id) {
                <button
                  type="button"
                  role="option"
                  class="menu-item"
                  [class.on]="agency.id === currentAgency?.id"
                  [attr.aria-selected]="agency.id === currentAgency?.id"
                  (click)="switchAgency(agency)"
                >
                  <span
                    class="avatar"
                    [class.bg-primary]="agency.id === currentAgency?.id"
                    [class.text-primary-foreground]="agency.id === currentAgency?.id"
                  >
                    {{ agency.name.charAt(0) }}
                  </span>
                  <span class="flex min-w-0 flex-1 flex-col">
                    <span class="truncate text-sm font-medium">{{ agency.name }}</span>
                    @if (agency.iata_number) {
                      <span class="text-xs text-muted-foreground">
                        IATA {{ agency.iata_number }}
                      </span>
                    }
                  </span>
                  @if (agency.id === currentAgency?.id) {
                    <app-icon name="check" />
                  }
                </button>
              } @empty {
                <p class="px-2 py-3 text-sm text-muted-foreground">No agencies found.</p>
              }
            </div>
            <p class="m-0 border-t border-border px-3 py-2.5 text-xs text-muted-foreground">
              Only agencies where you are a manager are listed.
            </p>
          </div>
        }
      </div>
    </header>

    <main class="main">
      <router-outlet />
    </main>
  </div>
</div>
